import React from 'react';

export interface AccordionProps {
    children: React.ReactNode;
    groupHeading?: string;
    blockId?: string;
    anchorTitle?: string;
}

const Accordion = ({ children, groupHeading, blockId, anchorTitle }: AccordionProps) => (
    <>
        {(blockId && anchorTitle) && (
            <section className="accordion use-theme" id={blockId} data-anchor-title={anchorTitle}>
                <div className="container">
                    {groupHeading && (
                        <h3 className="accordion-group-heading">
                            {{ groupHeading }}
                        </h3>
                    )}
                    {children}
                </div>
            </section>
        )}
        {(!blockId || !anchorTitle) && (
            <section className="accordion use-theme">
                <div className="container">
                    {groupHeading && (
                        <h3 className="accordion-group-heading">
                            {{ groupHeading }}
                        </h3>
                    )}
                    {children}
                </div>
            </section>
        )}
    </>
);
export default Accordion;
